import { CalendarDialog } from "./CalendarDialog";
import { connect } from "../connect-with-dialog";
import { travelData, updateDates } from "@escapio/portal/state/travelData";

customElements.define(
	"esc-calendar-button",
	class extends connect(CalendarDialog, HTMLElement) {
		getDialogParams() {
			return [travelData.arrival, travelData.departure];
		}

		onDialogConfirm({ detail }) {
			updateDates(detail.arrival, detail.departure);
		}
	},
);
